/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-pgc-标签管理
 */
'use strict';
angular.module("labelManagementModule",[]).
controller('labelManagementCtrl', ['$scope','$state','httpService',function($scope,$state,httpService){
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus(){
        $scope.status = {
            inputData:''
        };
        $scope.page = {
            "CURRPAGE": 1,
            "PAGESIZE": 10,
            "ITEMCOUNT": 0
        };
        $scope.data = {
            listData: [],
        };
    };

    function initData(){
        requestData();
    };
    /**
     * [requestData description] 初始数据
     * @return {[type]} [description]
     */
    $scope.requestData = function() {
        requestData();
    };
    function requestData() {
    	var params = {
    		currPage: $scope.page.CURRPAGE,
            pageSize: $scope.page.PAGESIZE,
    	}
        $scope.loadingPromise = httpService.http("/mcnadmin/admin/channel/channels.do", params, "post").then(function(data) {
            $scope.data.listData = data.data.ldata;
            $scope.page = {
                CURRPAGE: data.data.startPage,
                PAGESIZE: data.data.pageSize,
                ITEMCOUNT: data.data.totalResults,
                PAGECOUNT: data.data.totalPages
            };
        })
    }
}]);